export default function setSearchFirmAction(searchFirm) {
    return {
        type: 'SET_SEARCH_FIRM',
        payload: searchFirm
    }
}